import React from 'react'
import Navbar from '../../LandingPage/Navbar/Navbar'
import NewsRoomSection from '../../NewsRoomSection/NewsRoomSection'
import Footer2 from '../../Footer2/Footer2'
import TopBar from '../../EdofSectionNew2/TopBar/TopBar'
const NewsRoomPage = () => {
  return (
    <div>
      <TopBar/>
      <Navbar />
      <NewsRoomSection />
      <Footer2 />
    </div>
  )
}

export default NewsRoomPage
